(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pattern-guide-buttons"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializePatternGuideButtons = (section) => {
      if (!section || section.dataset.patternGuideInitialized === 'true') {
        return;
      }

      section.dataset.patternGuideInitialized = 'true';

      const buttons = Array.from(
        section.querySelectorAll('.pattern-guide-button')
      );

      const selectionLabel = section.querySelector(
        '.pattern-guide-buttons__selection-label'
      );

      const selectionDescription = section.querySelector(
        '[data-pattern-guide-description]'
      );

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const wasSelected = button.getAttribute('aria-pressed') === 'true';

          buttons.forEach((otherButton) => {
            otherButton.setAttribute('aria-pressed', 'false');
          });

          if (wasSelected) {
            button.setAttribute('aria-pressed', 'false');

            if (selectionLabel) {
              selectionLabel.textContent = 'Choose an option to begin.';
            }

            if (selectionDescription) {
              selectionDescription.textContent = '';
              selectionDescription.hidden = true;
            }

            section.dispatchEvent(
              new CustomEvent('pattern-guide:filter', {
                bubbles: true,
                detail: {
                  filter: 'all'
                }
              })
            );

            return;
          }

          button.setAttribute('aria-pressed', 'true');

          const label =
            button.querySelector('.pattern-guide-button__label')?.textContent.trim() ||
            '';

          const description =
            button.dataset.patternDescription || '';

          const filter =
            button.dataset.patternFilter || 'all';

          if (selectionLabel) {
            selectionLabel.textContent = label;
          }

          if (selectionDescription) {
            selectionDescription.textContent = description;
            selectionDescription.hidden = description.length === 0;
          }

          section.dispatchEvent(
            new CustomEvent('pattern-guide:filter', {
              bubbles: true,
              detail: {
                filter: filter
              }
            })
          );
        });
      });
    };

    const initializeAllPatternGuideButtons = () => {
      document
        .querySelectorAll('[data-pattern-guide-buttons]')
        .forEach(initializePatternGuideButtons);
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeAllPatternGuideButtons
      );
    } else {
      initializeAllPatternGuideButtons();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector(
        '[data-pattern-guide-buttons]'
      );

      initializePatternGuideButtons(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pattern-guide-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializePatternGuideCards = (section) => {
      if (!section || section.dataset.patternCardsInitialized === 'true') return;
      section.dataset.patternCardsInitialized = 'true';

      const grid = section.querySelector('[data-pattern-guide-grid]');
      const cards = Array.from(section.querySelectorAll('[data-pattern-card]'));
      const emptyState = section.querySelector('[data-pattern-guide-empty]');
      const noResults = section.querySelector('[data-pattern-guide-no-results]');
      const resultsHeader = section.querySelector('[data-results-header]');
      const resultsHeading = section.querySelector('[data-results-heading]');
      const resultsIntro = section.querySelector('[data-results-intro]');
      const resultCount = section.querySelector('[data-pattern-result-count]');

      let activeGoal = '';
      let refinements = { skill: [], fabric: [], size: [] };

      const goalCopy = {
        scraps: {
          heading: 'Scrap-Friendly Quilt Patterns',
          intro: 'These patterns are designed to make the most of your fabric scraps while creating something beautiful.'
        },
        'first-star': {
          heading: 'Great First Star Quilt Patterns',
          intro: 'These approachable patterns are excellent places to begin building confidence with star quilts.'
        },
        'learn-diamonds': {
          heading: 'Learn Diamond Piecing',
          intro: 'Build your diamond-piecing skills one step at a time with these thoughtfully designed patterns.'
        },
        'shop-stash': {
          heading: 'Patterns for Using What You Have',
          intro: 'Turn the fabric already in your sewing room into a quilt you are excited to finish.'
        },
        'color-play': {
          heading: 'Patterns That Shine With Color',
          intro: 'These designs give you plenty of room to experiment with color placement and fabric combinations.'
        },
        'quick-finish': {
          heading: 'Quick-Finish Quilt Patterns',
          intro: 'Choose a satisfying project that makes a big impact without a long-term commitment.'
        },
        'no-y-seams': {
          heading: 'No Y-Seam Quilt Patterns',
          intro: 'Enjoy striking star designs without inset seams.'
        },
        challenge: {
          heading: 'Patterns for Your Next Challenge',
          intro: 'Stretch your skills with a rewarding project that teaches you something new.'
        },
        statement: {
          heading: 'Statement-Making Quilt Patterns',
          intro: 'These bold designs are made to become the centerpiece of a room.'
        },
        'try-y-seams': {
          heading: 'Ready to Try Y-Seams?',
          intro: 'Build confidence with patterns that help you practice this classic star-quilt technique.'
        },
        gift: {
          heading: 'Quilt Patterns That Make Meaningful Gifts',
          intro: 'Find a special project for celebrating someone you love.'
        }
      };

      const normalizeFilters = (value) => {
        return String(value || '')
          .split(',')
          .map((filter) => filter.trim().toLowerCase())
          .filter(Boolean);
      };

      const hasRefinements = () => {
        return refinements.skill.length > 0 ||
          refinements.fabric.length > 0 ||
          refinements.size.length > 0;
      };

      const matchesAny = (selectedValues, cardValues) => {
        if (selectedValues.length === 0) return true;
        return selectedValues.some((value) => cardValues.includes(value));
      };

      const updateResultsCopy = (visibleCount) => {
        const copy = goalCopy[activeGoal];

        if (resultsHeading) {
          resultsHeading.textContent = copy
            ? copy.heading
            : 'Patterns That Match Your Filters';
        }

        if (resultsIntro) {
          resultsIntro.textContent = copy
            ? copy.intro
            : 'Here are the patterns that match the details you selected.';
        }

        if (resultCount) {
          resultCount.textContent = visibleCount === 1
            ? '1 pattern matches what you’re looking for'
            : `${visibleCount} patterns match what you’re looking for`;
        }
      };

      const resetCards = () => {
        cards.forEach((card) => { card.hidden = true; });
        if (grid) grid.hidden = true;
        if (emptyState) emptyState.hidden = false;
        if (noResults) noResults.hidden = true;
        if (resultsHeader) resultsHeader.hidden = true;
      };

      const applyFilters = () => {
        if (!activeGoal && !hasRefinements()) {
          resetCards();
          return;
        }

        let visibleCount = 0;

        cards.forEach((card) => {
          const goalFilters = normalizeFilters(card.dataset.goalFilters);
          const fabricFilters = normalizeFilters(card.dataset.fabricFilters);
          const sizeFilters = normalizeFilters(card.dataset.sizeFilters);
          const skillFilter = String(card.dataset.skillFilter || '').trim().toLowerCase();

          const goalMatches = !activeGoal || goalFilters.includes(activeGoal);
          const skillMatches = refinements.skill.length === 0 ||
            refinements.skill.includes(skillFilter);
          const fabricMatches = matchesAny(refinements.fabric, fabricFilters);
          const sizeMatches = matchesAny(refinements.size, sizeFilters);

          const shouldShow =
            goalMatches &&
            skillMatches &&
            fabricMatches &&
            sizeMatches;

          card.hidden = !shouldShow;
          if (shouldShow) visibleCount += 1;
        });

        if (emptyState) emptyState.hidden = true;
        if (resultsHeader) resultsHeader.hidden = false;
        if (grid) grid.hidden = visibleCount === 0;
        if (noResults) noResults.hidden = visibleCount !== 0;

        updateResultsCopy(visibleCount);
      };

      document.addEventListener('pattern-guide:filter', (event) => {
        const filterAliases = {
          'use-my-stash': 'shop-stash',
          'use-stash': 'shop-stash',
          'use-what-i-have': 'shop-stash'
        };

        const incomingFilter = event.detail?.filter || 'all';
        const normalizedFilter =
          filterAliases[incomingFilter] || incomingFilter;

        activeGoal =
          normalizedFilter === 'all'
            ? ''
            : normalizedFilter;

        applyFilters();
      });

      document.addEventListener('pattern-guide:refine', (event) => {
        refinements = {
          skill: Array.isArray(event.detail?.skill) ? event.detail.skill : [],
          fabric: Array.isArray(event.detail?.fabric) ? event.detail.fabric : [],
          size: Array.isArray(event.detail?.size) ? event.detail.size : []
        };

        applyFilters();
      });

      resetCards();
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-pattern-guide-cards]').forEach(initializePatternGuideCards);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll);
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.matches('[data-pattern-guide-cards]')
        ? event.target
        : event.target.querySelector('[data-pattern-guide-cards]');
      initializePatternGuideCards(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pattern-guide-filters"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializePatternGuideFilters = (section) => {
      if (!section || section.dataset.patternFiltersInitialized === 'true') return;
      section.dataset.patternFiltersInitialized = 'true';

      const checkboxes = Array.from(section.querySelectorAll('input[type="checkbox"][data-filter-group]'));
      const clearButton = section.querySelector('[data-clear-pattern-filters]');

      const getSelections = () => {
        const selections = { skill: [], fabric: [], size: [] };
        checkboxes.forEach((checkbox) => {
          if (!checkbox.checked) return;
          const group = checkbox.dataset.filterGroup;
          if (selections[group]) selections[group].push(checkbox.value);
        });
        return selections;
      };

      const updateClearButton = () => {
        if (clearButton) clearButton.hidden = !checkboxes.some((checkbox) => checkbox.checked);
      };

      const announceSelections = () => {
        updateClearButton();
        document.dispatchEvent(new CustomEvent('pattern-guide:refine', { detail: getSelections() }));
      };

      checkboxes.forEach((checkbox) => checkbox.addEventListener('change', announceSelections));

      if (clearButton) {
        clearButton.addEventListener('click', () => {
          checkboxes.forEach((checkbox) => { checkbox.checked = false; });
          announceSelections();
        });
      }

      document.addEventListener('pattern-guide:clear-refinements', () => {
        checkboxes.forEach((checkbox) => { checkbox.checked = false; });
        updateClearButton();
      });
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-pattern-guide-filters]').forEach(initializePatternGuideFilters);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll);
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.matches('[data-pattern-guide-filters]')
        ? event.target
        : event.target.querySelector('[data-pattern-guide-filters]');
      initializePatternGuideFilters(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
